import React, { useContext, useMemo } from 'react';
import { Page, PageContextType } from '../types';
import { PageContext } from '../PageContext';

interface CategoryCardProps {
    title: string;
    imageUrl: string;
    onClick: () => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ title, imageUrl, onClick }) => (
    <div 
        className="rounded-3xl p-2 cursor-pointer transition transform hover:-translate-y-1"
        style={{ backgroundColor: 'var(--primary-dark-purple)' }}
        onClick={onClick}
    >
        <div className="border-4 border-white rounded-2xl p-2 relative">
             <img src={imageUrl} className="w-full h-[120px] object-cover rounded-xl" alt={title} />
             <div className="absolute bottom-4 left-4 right-4">
                <h2 className="text-white font-extrabold text-2xl text-center tracking-wide" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.7)' }}>{title.toUpperCase()}</h2>
             </div>
        </div>
    </div>
);

const CategoriesPage: React.FC = () => {
    const pageContext = useContext(PageContext);

    const handleCategoryClick = (category: string) => {
        if (category === "Featured Brands") {
            pageContext?.switchPage(Page.FeaturedBrands, "Featured Brands");
        } else {
            pageContext?.switchPage(Page.FilteredFeed, category, { category });
        }
    };

    const standardCategories = [
        { title: "What was it?", imageUrl: "https://images.unsplash.com/photo-1579546929518-9e396f3cc809?q=80&w=2070&auto=format&fit=crop" },
        { title: "Where am I?", imageUrl: "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?q=80&w=2070&auto=format&fit=crop" },
        { title: "Who is it?", imageUrl: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1961&auto=format&fit=crop" },
        { title: "What film is it?", imageUrl: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?q=80&w=1756&auto=format&fit=crop" },
        { title: "What's that song?", imageUrl: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?q=80&w=2070&auto=format&fit=crop"},
        { title: "What's the lyrics?", imageUrl: "https://images.unsplash.com/photo-1520627514338-348ff980dd2a?q=80&w=2069&auto=format&fit=crop"},
        { title: "Who's the artist?", imageUrl: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=600&auto=format&fit=crop"},
        { title: "What's the year?", imageUrl: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?q=80&w=1974&auto=format&fit=crop"},
        { title: "What's that noise?", imageUrl: "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?q=80&w=2069&auto=format&fit=crop"},
        { title: "Featured Brands", imageUrl: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=2070&auto=format&fit=crop" },
    ];

    const categoriesWithAds = useMemo(() => {
        return standardCategories;
    }, [standardCategories]);

    return (
        <div className="space-y-4">
            {categoriesWithAds.map(item => {
                return (
                    <CategoryCard
                        key={item.title}
                        title={item.title}
                        imageUrl={item.imageUrl}
                        onClick={() => handleCategoryClick(item.title)}
                    />
                );
            })}
        </div>
    );
};

export default CategoriesPage;